module.exports = __webpack_public_path__ + "media/customizations/montaneranch/back-e84e2307babf54ad5a41b7a4a7c31035.jpg";